import React, { useState } from "react"

export const Aside = () => {
	const [activeSection, setActiveSection] = useState(null)

	const toggleSection = (section) => {
		setActiveSection(activeSection === section ? null : section)
	}

	return (
		<aside className="sidebarNavigation">
			<h2>Resources</h2>

			{/* About iLEARN */}
			<div>
				<h3
					style={{ color: "#fff" }}
					onClick={() => toggleSection("about")}
				>
					About iLEARN
				</h3>
				<ul style={{ display: activeSection === "about" ? "block" : "none" }}>
					<li>
						<a
							href="https://usahs.sharepoint.com/sites/USAHSStudentResources/SitePages/About-iLEARN.aspx?csf=1&web=1&e=zExR0s"
							target="_blank"
							rel="noopener noreferrer"
						>
							Mission & Advisory Committees
						</a>
					</li>
				</ul>
			</div>

			<div>
				<h3 style={{ color: "#fff" }}>
					<a
						href="https://ilearn.usa.edu/allvideos/"
						title="All Videos"
						target="_blank"
						rel="noreferrer"
						style={{
							color: "#fff"
						}}
					>
						Workshops and Recordings
					</a>
				</h3>
			</div>

			<div>
				<h3 style={{ color: "#fff" }}>
					<a
						href="https://usahs.sharepoint.com/sites/USAHSMicro-Credentials"
						title="Office of Micro-Credentials"
						target="_blank"
						rel="noreferrer"
						style={{
							color: "#fff"
						}}
					>
						Office of Micro-Credentials
					</a>
				</h3>
			</div>
			<div>
				<h3
					style={{ color: "#fff" }}
					onClick={() => toggleSection("clinicalInnovation")}
				>
					Clinical Innovation
				</h3>
				<ul
					style={{
						display: activeSection === "clinicalInnovation" ? "block" : "none"
					}}
				>
					<li>
						<a
							href="https://library.usa.edu/library-innovation-and-creation-hub"
							target="_blank"
							rel="noopener noreferrer"
						>
							Innovation and Creation Hub
						</a>
					</li>
					<li>
						<a
							href="https://usahs.sharepoint.com/sites/CentersforInnovativeClinicalPractice"
							target="_blank"
							rel="noopener noreferrer"
						>
							Centers for Innovative Clinical Practice
						</a>
					</li>
					<li>
						<a
							href="https://usahs.sharepoint.com/sites/USAHSProBonoClinicalExperiences"
							target="_blank"
							rel="noopener noreferrer"
						>
							Pro Bono Clinical Experiences
						</a>
					</li>
				</ul>
			</div>
			<div>
				<h3
					style={{ color: "#fff" }}
					onClick={() => toggleSection("about")}
				>
					<a
						href="https://usahs.sharepoint.com/sites/USAHSStudentResources/SitePages/Generative-AI.aspx?CT=1753732220126&OR=OWA-NT-Mail&CID=42cf84d8-94e2-5690-5c74-7ea93d3d9e0e&csf=1&web=1&e=xiJ3Wv"
						target="_blank"
						rel="noreferrer"
						style={{
							color: "#fff"
						}}
					>
						GEN AI Hub
					</a>
				</h3>
			</div>
			<div>
				<h3 style={{ color: "#fff" }}>
					<a
						href="https://usahs.sharepoint.com/sites/USAHSStudentResources/SitePages/Navigating-the-Online-Learning-Environment.aspx"
						target="_blank"
						rel="noreferrer"
						style={{
							color: "#fff"
						}}
					>
						Technology Toolbox
					</a>
				</h3>
			</div>
			<div>
				<h3
					style={{ color: "#fff" }}
					onClick={() => toggleSection("library")}
				>
					Library
				</h3>
				<ul style={{ display: activeSection === "library" ? "block" : "none" }}>
					<li>
						<a
							href="https://library.usa.edu/"
							target="_blank"
							rel="noopener noreferrer"
						>
							Library Resources
						</a>
					</li>
					<li>
						<a
							href="https://soar.usa.edu/"
							target="_blank"
							rel="noopener noreferrer"
						>
							SOAR@USA
						</a>
					</li>
					<li>
						<a
							href="https://soar.usa.edu/sjot"
							target="_blank"
							rel="noopener noreferrer"
						>
							Student Journal of Occupational Therapy
						</a>
					</li>
					<li>
						<a
							href="https://class.usa.edu/webapps/blackboard/content/listContentEditable.jsp?content_id=_2233388_1&course_id=_17671_1"
							target="_blank"
							rel="noopener noreferrer"
						>
							Scholarly Skills Community
						</a>
					</li>
				</ul>
			</div>
			<div>
				<h3
					style={{
						"line-height": "1.25em",
						"padding": "1em 0",
						"color": "#fff"
					}}
				>
					<a
						href="https://usahs.sharepoint.com/sites/USAHSMicro-Credentials/SitePages/USAHS-IPE-Case-Competition.aspx"
						title="Interprofessional Education and Collaborative Practice"
						target="_blank"
						rel="noreferrer"
						style={{
							color: "#fff"
						}}
					>
						Interprofessional Education and Collaborative Practice
					</a>
				</h3>
			</div>
			<div>
				<h3 style={{ color: "#fff" }}>
					<a
						href="https://my.usa.edu/ICS/Career_Services/"
						title="Career Services"
						target="_blank"
						rel="noreferrer"
						style={{
							color: "#fff"
						}}
					>
						Career Services
					</a>
				</h3>
			</div>
			<div>
				<h3 style={{ color: "#fff" }}>
					<a
						href="https://my.usa.edu/ICS/Student_Services/"
						title="Student Services"
						target="_blank"
						rel="noreferrer"
						style={{
							color: "#fff"
						}}
					>
						Student Services
					</a>
				</h3>
			</div>
		</aside>
	)
}

export default Aside
